import { colorBaseWhite } from '@hse-design/tokens';
import { createPopper } from '@popperjs/core';
import __vue_component__ from './HsePopperArrow.vue.js';

//

/**
 * @react /src-components-popper
 * @requires ./HsePopperArrow.vue
 */
var script = {
  name: 'HsePopper',
  components: {HsePopperArrow: __vue_component__},
  props: {
    /**
     * Стрелка
     */
    arrow: {
      type: Boolean,
      default: false,
    },
    /**
     * Цвет стрелки
     */
    arrowColor: {
      type: String,
      default: colorBaseWhite
    },
    /**
     * Элемент, относительно которого позиционироваться
     */
    appendTo: {
      default: ''
    },
    /**
     * Расположение Popper
     * @values top, bottom, right, left, top-start, top-end, bottom-start, bottom-end, right-start, right-end, left-start, left-end, auto, auto-start, auto-end
     */
    placement: {
      type: String,
      default: 'auto'
    },
    /**
     * Объект настроек Popper.js
     */
    popperOptions: {
      type: Object,
      default: () => ({})
    }
  },

  data() {
    return {
      popper: undefined
    }
  },

  watch: {
    placement(v) {
      try {
        this.updateOptions({
          placement: v
        });
      } catch (e) {
        console.warn(e);
      }
    },
    popperOptions: {
      deep: true,
      handler(v) {
        try {
          this.updateOptions(v);
        } catch (e) {
          console.warn(e);
        }
      }
    },
    appendTo(target) {
      target ? this.init() : this.destroy();
    }
  },

  async mounted() {
    this.$nextTick(() => {
      this.init();
    });
  },

  methods: {
    destroy() {
      if (this.popper) {
        this.popper.destroy();
        this.popper = undefined;
      }
    },
    init() {
      if (!this.appendTo) return;
      if (this.popper) this.destroy();

      let appendTo = this.appendTo;
      if (typeof appendTo === 'string') {
        appendTo = document.querySelector(appendTo);
      } else if (typeof appendTo === 'object' && appendTo.$el) {
        appendTo = appendTo.$el;
      }

      if (!appendTo) return;

      const options = {
        placement: this.placement
      };
      const mergedOptions = {...options, ...this.popperOptions};
      this.popper = createPopper(appendTo, this.$el, mergedOptions);
      this.updatePopper();
      return this.popper;
    },
    updatePopper() {
      if (!this.popper) return this.init();
      return this.popper.update()
    },
    updateOptions(newOptions = {}) {
      if (!this.popper) return this.init()
      return this.popper.setOptions(newOptions)
    }
  },
};

export default script;
